module.exports = __webpack_public_path__ + "img/box3_img3_light.0a264ad9.png";